export default "__VITE_ASSET__b444e480__"